import styled from 'styled-components';
import { COLOR_DARK_PURPLE, COLOR_WHITE, COLOR_DARKER_GREY } from '../../../assets/styles/colors';
import { rgba } from 'polished';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export default styled.div`
  padding-top: 35px;
  height: auto;
  @media (max-width: ${BP_TABLET_MAX}px) {
    padding-top: 20px;
  }
`;

export const EmptyArrearsSC = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  border-radius: 12px;
  width: 100%;
  height: 100%;
  min-height: 265px;
  background: ${rgba('#EDECEE', 0.5)};
  .no-arrears {
    margin-top: 24px;
    color: ${rgba(COLOR_DARK_PURPLE, 0.2)};
  }
`;

export const DataArrearsSC = styled.div`
  background: ${COLOR_WHITE};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
  .headline-data-wrap {
    display: flex;
    justify-content: space-between;
  }
  .body-data-wrap {
    background: ${COLOR_DARKER_GREY};
    border-radius: 12px;
    padding: 16px 0;
    margin-top: 24px;
    &--item {
      padding: 8px 16px 0px 16px;

      .full-arrear {
        padding-bottom: 6px;
      }
      &:first-child {
        padding-top: 0px;
      }

      &__body-row {
        display: flex;
        justify-content: space-between;

        &.padded-small {
          small {
            padding: 0 0 0 0;
          }
        }
      }
    }
  }
  .summary-wrap {
    padding-top: 24px;
    &--amount {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    button {
      margin-top: 24px;
      width: 100%;
    }
  }
`;
